import { render, staticRenderFns } from "./Solar.vue?vue&type=template&id=6335014a&"
import script from "./Solar.vue?vue&type=script&lang=js&"
export * from "./Solar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports